module.exports = __webpack_public_path__ + "static/media/sac-logo.997f9054.png";